import { darken } from 'polished';
import styled from 'styled-components';
import { COLORS } from '@/constants/styles';
import { safePolished } from '@/utils/safePolished';

/*
  Custom radio / checkboxes
*/
interface StyledCheckboxProps {
  isLoading?: boolean;
  width?: number;
}

export const StyledCheckbox = styled.div<StyledCheckboxProps>`
  opacity: ${({ isLoading }) => (isLoading ? 0.3 : 1)};
  pointer-events: ${({ isLoading }) => (isLoading ? 'none' : 'all')};
  position: relative;

  ${({ width }) =>
    width &&
    `
    width: ${width}%;
  `}

  p {
    bottom: 5px;
    color: ${({ theme }) => theme.global.error_color};
    font-size: 12px;
    left: 0;
    margin: 0;
    padding: 0;
    position: absolute;
  }

  .control {
    font-size: ${({ theme }) => theme.text.primary_font.font_size ?? 16}px;
    position: relative;
    display: flex;
    margin-bottom: 10px;
    margin-top: 20px;
    padding-left: 30px;
    cursor: pointer;
    line-height: 22px;
    text-align: left;

    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .control input {
    left: 0px;
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  .control__indicator {
    position: absolute;
    top: 0px;
    left: 0;
    width: 20px;
    height: 20px;
    background: white;
    border: 2px solid ${COLORS.PRIMARY_NAVY_X_LIGHT};
    border-radius: 4px;
  }

  .control--radio .control__indicator {
    border-radius: 50%;
  }

  /* Focus states */
  .control--checkbox input:focus ~ .control__indicator {
    border: 2px solid ${({ theme }) => theme.global.primary_active_color};
  }

  /* Checked state */
  .control input:checked ~ .control__indicator {
    background: ${({ theme }) => theme.global.primary_active_color};
    border: 2px solid ${({ theme }) => theme.global.primary_active_color};
  }

  /* Focus state whilst checked */
  .control--checkbox input:checked:focus ~ .control__indicator {
    background: ${({ theme }) => theme.global.primary_active_color};
    border: 2px solid ${({ theme }) =>
      safePolished(darken)(0.1, theme.global.primary_active_color)};
  }

  .control--radio input:checked:focus ~ .control__indicator {
    border: 2px solid ${({ theme }) => theme.global.primary_active_color};
  }

  /* Disabled state */
  .control input:disabled ~ .control__indicator {
    pointer-events: none;
    opacity: .6;
  }

  /* Check mark */
  .control__indicator:after {
    position: absolute;
    display: none;
    content: '';
  }

  /* Show check mark */
  .control input:checked ~ .control__indicator:after {
    display: block;
  }

  /* Checkbox tick */
  .control--checkbox .control__indicator:after {
    top: 2px;
    left: 5px;
    width: 4px;
    height: 9px;
    transform: rotate(45deg);
    border: solid #fff;
    border-width: 0 2px 2px 0;
  }

  /* Disabled tick colour */
  .control--checkbox input:disabled ~ .control__indicator:after {
    border-color: #7b7b7b;
  }

  /* Radio button inner circle */
  .control--radio input:checked ~ .control__indicator {
    background: white;
    border: 1px solid ${COLORS.PRIMARY_NAVY_X_LIGHT};
  }
  .control--radio .control__indicator:after {
    top: 0;
    left: -1px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: transparent url('/img/radio-selected.svg') no-repeat 0 0;
  }

  /* Disabled circle colour */
  .control--radio input:disabled ~ .control__indicator:after {
    background: #7b7b7b;
  }

  .error-message {
    position: absolute;
    top:-15px;
  }
}`;
